// extracted by mini-css-extract-plugin
export var attachment = "_l6-a";
export var emailContainer = "_l6-4";
export var emailContentPaddedContainer = "_l6-b";
export var emailHeader = "_l6-6";
export var emailIframe = "_l6-3";
export var emailInfoIcon = "_l6-9";
export var emailShortenedSummary = "_l6-e";
export var infoDropdown = "_l6-0";
export var infoRowBoundedContent = "_l6-d";
export var internal = "_l6-5";
export var merchant = "_l6-8";
export var messageInputContainer = "_l6-h";
export var normal = "_l6-7";
export var replyCard = "_l6-f";
export var subtleButton = "_l6-1";
export var subtleButtonIconContainer = "_l6-2";
export var toggleViewRepliesButton = "_l6-c";
export var wrappingText = "_l6-g";